import React from "react";
import logo from "../assets/images/logo-login.png";

export default function AuthShell({
  title,
  subtitle,
  children,
  maxWidth = "max-w-[440px]",
}) {
  return (
    <div className="min-h-screen bg-[#3d3935] flex flex-col items-center justify-center px-4 py-8">
      <div className="mb-8 text-center w-full mt-[10px] max-w-[240px]">
        <img src={logo} alt="Authentication Logo" className="w-full h-auto" />
      </div>

      <div
        className={`w-full bg-white shadow-login px-[24px] sm:px-[40px] pt-[20px] pb-[20px] ${maxWidth} mx-auto rounded-[12px] sm:rounded-[15px]`}
      >
        <h1 className="text-[18px] font-semibold text-[#3d3935] mt-[4px] mb-[6px] text-center">
          {title}
        </h1>

        {subtitle && (
          <p className="text-[13px] text-[#6b6b6b] mb-[18px] text-center leading-[1.5]">
            {subtitle}
          </p>
        )}

        {children}
      </div>
    </div>
  );
}